// extracted by mini-css-extract-plugin
module.exports = {"slide":"noti_slide_-5rb2","slide-reverse":"noti_slide-reverse_2myKI","action":"noti_action_2DzBE","chat":"noti_chat_2rfdK","empty":"noti_empty_2mFYt"};